import React from "react"

import Container from "mse-tool-components/lib/components/Container"
import TitleBanner from "mse-tool-components/lib/components/TitleBanner"
import Breadcrumbs from "mse-tool-components/lib/components/Breadcrumbs"
import PageMeta from "../../components/PageMeta"
import VisitorPixel from "mse-tool-components/lib/components/VisitorPixel"
import { CREDIT_CARDS } from "mse-tool-components/lib/utils/DimChannel"

import StandAlonePage from "mse-tool-components/lib/components/PageFurniture/StandAlonePage"
import StandAloneContentContainer from "mse-tool-components/lib/components/PageFurniture/StandAloneContentContainer"

import ProviderList from "../../components/ProviderList/ProviderList"
import CreditCardsArticle from "../../components/CreditCards/CreditCardsArticle"

import metaData from "../../utils/page-meta.json"

import "mse-tools-masthead-and-footer/lib/css/page-base.css"
import "mse-tools-masthead-and-footer/lib/css/stand-alone-page.css"
import "mse-tool-components/lib/css/index.css"
import "../../scss/credit-cards.scss"
const CreditCards = () => {
  return (
    <>
      <PageMeta metaData={metaData.creditCards} />
      <StandAlonePage>
        <StandAloneContentContainer>
          <TitleBanner
            title="Credit Card Eligibility Calculator"
            subtitle="Find which credit cards you're most likely to be accepted for - protecting your Credit Score"
            className="header-banner"
            socialshares={false}
            fullWidth={true}
            imagePosition="right"
            breadcrumbs={
              <Breadcrumbs
                items={[
                  {
                    text: "Eligibility Calculator",
                    href: "https://www.moneysavingexpert.com/eligibility/",
                  },
                  {
                    text: "Credit Card Eligibility Calculator",
                    href:
                      "https://www.moneysavingexpert.com/eligibility/credit-cards/",
                  },
                ]}
              />
            }
          />

          <Container
            id={process.env.npm_package_name}
            versionNumber={process.env.npm_package_version}
            toolType="standAlone"
          >
            <div className="container-row row">
              <div className="article-container col-12 col-sm-12">
                <CreditCardsArticle />
              </div>
            </div>
            <ProviderList />
          </Container>
          <VisitorPixel
            pageId={process.env.npm_package_name}
            channel={CREDIT_CARDS}
          />
        </StandAloneContentContainer>
      </StandAlonePage>
    </>
  )
}

export default CreditCards
